import { reportingQueryString } from './query-string.js';
import { uoReportingAPI } from './api-call.js';
import { tinCannyDashboard } from './reporting-dashboard.js';
import { isDefined } from './utilities.js';
import {reportingTabs} from "./tabs";

var dataObject = {

    dataObjectPopulated: false,
    courseList: {},
    lessonList: {},
    topicList: {},
    quizList: {},
    assignmentList: {},
    userList: {},
    groupsList: {},
    dataTables: {},
    learnDashLabels: {},
    links: {},
    localizedStrings: {},
    additionalData: [],

    getData: function ( tab = '', onSuccess = null, onError = null ){
        if ( reportingQueryString.isTinCanOnly ){
			return;
		}

		dataObject.dataObjectPopulated = true;
		// Load UI from wp dashboard

		let currentTab = '';
		// Then initialize the current tab
		let activeTab = reportingApiSetup.current_tab;

		switch ( activeTab ) {
			case 'uncanny-tincanny-user-report':
				currentTab = 'userReportTab';
				break;
			case 'uncanny-tincanny-tin-can-report':
				currentTab = 'tin-can';
				break;
			case 'uncanny-tincanny-xapi-quiz-report':
				currentTab = 'xapi-tincan';
				break;
			case 'uncanny-learnDash-reporting':
			default:
				currentTab = 'courseReportTab';
				break;
		}

		// course or user report overview is not needed
		if( 'tin-can' === currentTab || 'xapi-tincan' === currentTab ){
			return;
		}

		let data= '';
		// Api Call wrapper get course overview ( User List with data and Course List with data )
		if (typeof reportingApiSetup.isolated_group_id === 'string' && parseInt(reportingApiSetup.isolated_group_id)) {
		  data = data + '?group_id=' + reportingApiSetup.isolated_group_id;
		}

		let endpoint = 'courses_overview';

		if( 'userreporttab' === currentTab ){
			endpoint = 'users_overview';
		}

		var coursesOverviewApiCall = uoReportingAPI.reportingApiCall(endpoint, data);

		coursesOverviewApiCall.fail(function (response) {

			var failedResponseEl = document.getElementById('failed-response');
			failedResponseEl.innerHTML = response.responseText;

			jQuery('#reporting-loader').hide('slow', function () {
				failedResponseEl.style.display = "block";
			});

			// Check if the onError function is defined and invoke it
			if ( isDefined( onError ) ){
				onError();
			}
		});

		coursesOverviewApiCall.done((response) => {
			// Load dashboard only if the current tab is courseReportTab
			if( reportingTabs.currentTabID === 'courseReportTab' ){
				// Save data
				tinCannyDashboard.dataObject = response.data.userList.dashboard_data;
				tinCannyDashboard.renderData();
			}

			// Set links
			this.setLinks( response.links );

			// Load initial data into data object
			dataObject.setCourseList(response.data.courseList);
			dataObject.userList.completed = response.data.userList.completions;
			dataObject.userList.inProgress = response.data.userList.in_progress;
			dataObject.userList.allUserIds = extractIDs(response.data.userList.users_overview);
			//dataObject.userList.courseAccessCount = response.data.userList.course_access_count;
			dataObject.userList.userOverview = response.data.userList.users_overview;
			dataObject.userList.course_user_access_list = response.data.userList.course_access_list;
			dataObject.userList.courseQuizAverages = response.data.userList.course_quiz_averages;
			//dataObject.userList.courseCompletionByDates = response.data.userList.course_completion_by_dates;
			dataObject.userList.courseCompletionByCourse = response.data.userList.course_completion_by_course;
			dataObject.additionalData['coursesOverview'] = response.additionalData;

			// Expose dataObject globally for other plugins to use
			window.tincannyDataObject = dataObject;

			// Check if the onSuccess function is defined and invoke it
			if ( isDefined( onSuccess ) ){
				onSuccess();
			}
		});
    },

    setCourseList: function (courseList) {
        this.courseList = courseList;
    },

    getCourseList: function () {
        return this.courseList;
    },

    addToCourseList: function (courseID, name, data, type) {

        switch (type) {
            case 'string':
                data = String(data);
                break;
            default:
                data = Number(data);
                break;
        }


        if (this.courseList[courseID]) {
            this.courseList[courseID][name] = data;
        }

    },

    getUserList: function () {
        return this.userList;
    },

    setLinks: function (links) {
        this.links = links;
    },

    addToDataTables: function (tableName, tableData) {

        if ( isDefined( wp.hooks ) ){
            tableData = wp.hooks.applyFilters( 'tc_addToDataTables_data', tableData, tableName );
        }

        this.dataTables[tableName] = tableData;
    },

    tableEmptyCellPlaceholder: function () {
        return '';
    },

    addToTinCanStatements: function (userID, courseStatements) {

        if (typeof this.userList[userID] !== 'undefined') {
            this.userList[userID].tinCanStatements = courseStatements;
        }

    },

    singleUserCoursePercentComplete: function (userID, courseID) {

		return this.tableEmptyCellPlaceholder();
    },

    singleUserCourseStatus: function (userID, courseID) {

        var percentComplete = this.singleUserCoursePercentComplete(userID, courseID);

        percentComplete = parseInt(percentComplete);

        var status = ls('Not Started');

        if (percentComplete < 100 && percentComplete !== 0) {
            status = ls('In Progress');
        }

        if (percentComplete === 100) {
            status = ls('Completed');
        }

        return status;
    },

    singleUserCourseAvgQuizScore: function (userID, courseID) {

        var avgQuizScore = this.tableEmptyCellPlaceholder();

        if (typeof this.courseList[courseID].associatedPosts === 'undefined') {
            return avgQuizScore;
        }

        var courseAssociatedPosts = this.courseList[courseID].associatedPosts;

        var cumulativePercentage = 0;

        var amountQuizzes = 0;

        // Loop through all modules associated with current course
        jQuery.each(courseAssociatedPosts, function (index, courseAssociatedPost) {

            // Make sure the user has data for the current module before access module data
            if (typeof dataObject.userList.userOverview[userID]['quizzes'] !== 'undefined' &&
                typeof dataObject.userList.userOverview[userID]['quizzes'][0][courseAssociatedPost] !== 'undefined'
            ) {

                // Make sure the current module is a quiz
                if (typeof dataObject.userList.userOverview[userID]['quizzes'][0][courseAssociatedPost].type !== 'undefined' &&
                    dataObject.userList.userOverview[userID]['quizzes'][0][courseAssociatedPost].type === 'quiz'
                ) {

                    // Make sure there is quiz data
                    if (1 <= dataObject.userList.userOverview[userID]['quizzes'][0][courseAssociatedPost].attempts) {

                        // Choose the last(most recent quiz attempt); the attempts are indexed and there is one type object
                        var lastAttempt = dataObject.userList.userOverview[userID]['quizzes'][0][courseAssociatedPost].attempts - 1;

                        cumulativePercentage += parseInt(dataObject.userList.userOverview[userID]['quizzes'][0][courseAssociatedPost][lastAttempt].percentage);
                        amountQuizzes++;

                    }
                }
            }
        });

        if (0 !== amountQuizzes || 0 !== cumulativePercentage) {
            avgQuizScore = Math.ceil(cumulativePercentage / amountQuizzes) + '%';
        }

        return avgQuizScore;
    },

    formatSecondsToDate: function( seconds ){
        // Check if it's a number
        if ( isNaN( seconds ) ){
            return '';
        }

        // Get parts
        let timeParts = {
            hours:   Math.floor( seconds / 3600 ),
            minutes: Math.floor( ( seconds - ( timeParts.hours * 3600 ) ) / 60 ),
            seconds: Math.floor( seconds - ( timeParts.hours * 3600 ) - ( timeParts.minutes * 60 ) )
        }

        // Prepend zero before if the number if less than 10
        timeParts.hours   = timeParts.hours < 10 ? `0${ timeParts.hours }` : timeParts.hours;
        timeParts.minutes = timeParts.minutes < 10 ? `0${ timeParts.minutes }` : timeParts.minutes;
        timeParts.seconds = timeParts.seconds < 10 ? `0${ timeParts.seconds }` : timeParts.seconds;

        // Return time
        return `${ timeParts.hours }:${ timeParts.minutes }:${ timeParts.seconds }`;
    },
};

function extractIDs(data) {
	const ids = {};
	for (let key in data) {
		if (data.hasOwnProperty(key)) {
			ids[key] = key;
		}
	}
	return ids;
}

export {
    dataObject
}
